import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { parse as parseQuery } from 'query-string';
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

import useScrollToTop from '../../hooks/useScrollToTop';
import { getComponentFromName } from '../../lib/utils';

import { usePage } from '../../contexts/PagesContext';
import MainLayout from '../layouts/Main';
import PageMeta from '../partials/PageMeta';
import * as Pages from './index';

const propTypes = {
    keepLoadedPage: PropTypes.bool,
    withQuery: PropTypes.bool,
    edition: PropTypes.string,
};

const defaultProps = {
    keepLoadedPage: true,
    withQuery: true,
    edition: null,
};

const PageLoader = ({ keepLoadedPage, withQuery, edition }) => {
    const { pathname = null, search = null } = useLocation();
    const searchQuery = parseQuery(search, { arrayFormat: 'bracket' });
    const { loading, error, page } = usePage(
        pathname,
        !isEmpty(search) && withQuery ? searchQuery : null,
    );
    const [loadedPage, setLoadedPage] = useState(page);
    const currentSearch = useRef(search);

    const finalPage = keepLoadedPage && loading && page === null ? loadedPage : page;

    if (finalPage === page) {
        currentSearch.current = search;
    }

    const { type = null } = finalPage || {};

    let PageComponent = null;
    if (type !== null) {
        PageComponent = getComponentFromName(Pages, type, null);
    }

    useEffect(() => {
        if (keepLoadedPage && !loading && page !== null) {
            setLoadedPage(page);
        }
    }, [keepLoadedPage, loading, page, setLoadedPage]);

    const { id: pageId = null } = finalPage || {};
    useScrollToTop(pageId);

    // console.log('finalPage', finalPage);

    return (
        <MainLayout page={!error ? finalPage : null} pageLoading={loading}>
            {PageComponent !== null && finalPage !== null ? (
                <>
                    <PageMeta page={finalPage} />
                    <PageComponent
                        page={finalPage}
                        queryString={currentSearch.current}
                        edition={edition}
                    />
                </>
            ) : null}
        </MainLayout>
    );
};

PageLoader.defaultProps = defaultProps;
PageLoader.propTypes = propTypes;

export default PageLoader;
